import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useState } from "react";
import { IconButton, Link, Typography } from "@mui/material";
import { Button, Grid, Paper, TextField } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import BpCheckbox from "./CheckBox"
import Modal from '@mui/material/Modal';
import img from "./imageCane.png"
// import {Grid} from "@mui/material";
import EggAltIcon from '@mui/icons-material/EggAlt';
import LinearProgress from '@mui/material/LinearProgress';
import CloseIcon from '@mui/icons-material/Close';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  height: 550,
  bgcolor: 'background.paper',
  boxShadow: 24,
  overflowY: 'scroll'
};

const data1 = [
  {
    id: '1',
    title: 'Tomato Paste',
    quantity: '2 Pcs'
  },
  {
    id: '2',
    title: 'Olive Oil',
    quantity: '2 Pcs'
  },
  {
    id: '3',
    title: 'Garlic Clover',
    quantity: '2 Pcs'
  },
  {
    id: '4',
    title: 'Small Onion',
    quantity: '2 Pcs'
  },
  {
    id: '5',
    title: 'Black Pepper',
    quantity: '2 Pcs'
  },
];


export default function SelectDishesCards({ menus }) {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Realdata = menus[0]?.dishes
  console.log(Realdata)
  const data = [
    {
      id: "1",
      title: "Kabasa",
      image: "./images/kabab1.svg",
      details: "View Details",
      dayDate: "Wed, 02 Nov 2021",
    },
    {
      id: "1",
      title: "Kabasa",
      image: "./images/kabab2.svg",
      details: "View Details",
      dayDate: "Wed, 02 Nov 2021",
    },
    {
      id: "1",
      title: "Kabasa",
      image: "./images/kabab1.svg",
      details: "View Details",
      dayDate: "Wed, 02 Nov 2021",
    },
    {
      id: "1",
      title: "Kabasa",
      image: "./images/kabab2.svg",
      details: "View Details",
      dayDate: "Wed, 02 Nov 2021",
    },
  ];

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            textColor="inherit"
            indicatorColor="secondary"
          >
            <Tab label="Scheduled" value="1" />
            <Tab label="General" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Box>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
              <Box>
                <Typography
                  sx={{
                    marginBottom: "10px",
                    fontSize: "24px",
                    fontWeight: "600",
                  }}
                >
                  Scheduled Dishes
                </Typography>
              </Box>
              <Box>
                <FormGroup>
                  <FormControlLabel control={<Checkbox />} label="Select all" />
                </FormGroup>
              </Box>
            </Box>

            <Box>
              <Grid container spacing={4}>
                {Realdata?.map((v, i) => {
                  return (
                    <>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Card
                          sx={{
                            maxWidth: "318px",
                            paddingBottom: {
                              lg: "12px",
                              md: "12px",
                              sm: "20px",
                              xs: "18px",
                            },
                            borderRadius: "8px",
                            borderColor: "#E1E1E6",
                            backgroundColor: "#FFFFFF",
                            height: "235px",
                            boxShadow: "none",
                          }}
                        >
                          <CardActionArea>
                            {/* <CardMedia
                              component="img"
                              // height="144.42px"
                              height="fit-content"
                              width="318px"
                              image={v.image}
                              alt="green iguana"
                              Checkbox {...label} 
                            /> */}
                            <Box height="fit-content"
                              sx={{
                                width: { lg: "318px", md: "318px", sm: "318px", xs: "100%" },
                                backgroundImage: `url("./images/kabab2.svg")`,
                                backgroundRepeat: "no-repeat",
                                height: "144px"
                              }}>
                              <Box sx={{ display: "flex", justifyContent: "right", pr: "20px", }}>
                                {/* <Checkbox {...label}  sx={{display: "flex", justifyContent: "right", pr: "20px", color: "#E1E1E6", }} /> */}
                                <BpCheckbox />

                              </Box>
                            </Box>

                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // marginLeft: "12px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="div"
                                    fontWeight="500"
                                    lineHeight="26px"
                                    //   width="261px"
                                    sx={{
                                      fontSize: {
                                        lg: "24px",
                                        md: "24px",
                                        sm: "20px",
                                        xs: "18px",
                                      },
                                    }}
                                  // height="52px"
                                  >
                                    Kabasa
                                  </Typography>
                                </Box>

                                <Box>
                                  <Link component="button" onClick={() => handleOpen()}>
                                    <Typography
                                      sx={{
                                        // width: "16px",
                                        // height: "16px",
                                        fontSize: "16px",
                                        fontWeight: "400",
                                        lineHeight: "16px",
                                        paddingLeft: "9.5px",
                                        textDecoration: "underline",

                                        color: "#2B817B",
                                      }}
                                    >
                                      Quantity: {v.quantity}
                                    </Typography>
                                  </Link>
                                </Box>
                              </Box>

                              <Box
                                sx={{ display: "flex", flexDirection: "row" }}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    // width: "200px",
                                    // height: "20px",
                                    fontSize: "16px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {v.day}
                                </Typography>
                              </Box>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Grid>
                    </>
                  );
                })}
              </Grid>
            </Box>
          </Box>
        </TabPanel>

        <TabPanel value="2">Item Two</TabPanel>
      </TabContext>


      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{
            backgroundImage: "url(./images/selectdish1.png)",
            backgroundRepeat: "no-repeat",

            width: { lg: "100%", md: "100%", sm: "686px", xs: "95%" },
            height: {
              xl: "357.47px",
              lg: "357.47px",
              md: "310px",
              // md: "800px",
              sm: "310px",
              xs: "200px",
            },
            backgroundSize: {
              lg: "contain",
              md: "cover",
              sm: "contain",
              xs: "cover",
            },
          }}>
            <Box>
              <Box sx={{
                pt: '20px',
                ml: '25px'
              }}>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>

            </Box>
          </Box>
          <Box sx={{
            p: 4,
          }}>
            <Typography sx={{
              fontWeight: 600,
              fontSize: "30px"
            }}>
              Shawarma Plate
            </Typography>
            <Typography sx={{
              fontWeight: 400,
              fontSize: '15px',
              color: '#545359'
            }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </Typography>

            <Grid container spacing={3}>
              <Grid item lg={5} md={5} sm={12} xs={12}>
                <Box>
                  <Box>
                    <Typography sx={{
                      fontWeight: 600,
                      fontSize: '20px',
                      mt: '30px'
                    }}>
                      Ingridient
                    </Typography>
                  </Box>
                  {
                    data1 && data1.map((v, i) => {
                      return (
                        <>
                          <Box>
                            <Box sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              mt: '10px',
                              width: '100%'
                            }}>
                              <Box sx={{
                                width: '20px',
                                height: '20px',
                                border: '1px solid #9EA3AE',
                                borderRadius: '4px',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                padding: '5px'
                              }}>
                                <img src={img} />
                              </Box>
                              <Box sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}>
                                <Box sx={{ ml: "10px" }}>
                                  <Typography sx={{
                                    fontWeight: 600,
                                    fontSize: '18px'
                                  }}>
                                    {v.title}
                                  </Typography>
                                </Box>
                                <Box >
                                  <Typography sx={{ color: '#9EA3AE', fontWeight: 400, fontSize: '13px' }}>{v.quantity}</Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </>
                      )
                    })
                  }
                </Box>
              </Grid>
              <Grid item lg={7} md={7} sm={12} xs={12}>
                <Box sx={{ width: '100%' }}>
                  <Box>
                    <Typography sx={{
                      fontWeight: 600,
                      fontSize: '20px',
                      mt: '30px',
                      mb: '10px'
                    }}>
                      Nutritional Information
                    </Typography>
                  </Box>
                  <Box sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <Box>
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>

                        <Box sx={{
                          width: '40px',
                          height: '40px',
                          border: '1px solid #9EA3AE',
                          borderRadius: '50%',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          <EggAltIcon sx={{ color: '#9EA3AE' }} />
                        </Box>
                        <Box sx={{ ml: '10px' }}>
                          <Typography sx={{
                            fontWeight: 400,
                            fontSize: '15px',
                            color: ' #9EA3AE',
                          }}>
                            Protein
                          </Typography>
                          <Typography sx={{
                            fontWeight: 400,
                            fontSize: '13px',

                          }}>
                            33g
                          </Typography>
                        </Box>

                      </Box>
                    </Box>
                    <Box>
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>

                        <Box sx={{
                          width: '40px',
                          height: '40px',
                          border: '1px solid #9EA3AE',
                          borderRadius: '50%',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          <EggAltIcon sx={{ color: '#9EA3AE' }} />
                        </Box>
                        <Box sx={{ ml: '10px' }}>
                          <Typography sx={{
                            fontWeight: 400,
                            fontSize: '15px',
                            color: ' #9EA3AE',
                          }}>
                            Protein
                          </Typography>
                          <Typography sx={{
                            fontWeight: 400,
                            fontSize: '13px',

                          }}>
                            33g
                          </Typography>
                        </Box>

                      </Box>
                    </Box>
                    <Box>
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>

                        <Box sx={{
                          width: '40px',
                          height: '40px',
                          border: '1px solid #9EA3AE',
                          borderRadius: '50%',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          <EggAltIcon sx={{ color: '#9EA3AE' }} />
                        </Box>
                        <Box sx={{ ml: '10px' }}>
                          <Typography sx={{
                            fontWeight: 400,
                            fontSize: '15px',
                            color: ' #9EA3AE',
                          }}>
                            Protein
                          </Typography>
                          <Typography sx={{
                            fontWeight: 400,
                            fontSize: '13px',

                          }}>
                            33g
                          </Typography>
                        </Box>

                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ mt: '20px' }}>
                    <Box sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px'
                        }}>Vit A</Typography>
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px',
                          color: '#9EA3AE'
                        }}>3 gr</Typography>
                      </Box>
                    </Box>
                    <Box>
                      <LinearProgress variant="determinate" value={20} />
                    </Box>
                  </Box>
                  <Box sx={{ mt: '20px' }}>
                    <Box sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px'
                        }}>Vit B</Typography>
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px',
                          color: '#9EA3AE'
                        }}>3 gr</Typography>
                      </Box>
                    </Box>
                    <Box>
                      <LinearProgress variant="determinate" value={30} />
                    </Box>
                  </Box>
                  <Box sx={{ mt: '20px' }}>
                    <Box sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px'
                        }}>Calcium</Typography>
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px',
                          color: '#9EA3AE'
                        }}>3 gr</Typography>
                      </Box>
                    </Box>
                    <Box>
                      <LinearProgress variant="determinate" value={60} />
                    </Box>
                  </Box>
                  <Box sx={{ mt: '20px' }}>
                    <Box sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px'
                        }}>Iron</Typography>
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontWeight: 400,
                          fontSize: '13px',
                          color: '#9EA3AE'
                        }}>3 gr</Typography>
                      </Box>
                    </Box>
                    <Box>
                      <LinearProgress variant="determinate" value={40} />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>




          </Box>

        </Box>
      </Modal>



    </Box>
  );
}
